module.exports = __webpack_public_path__ + "static/media/pill-icon-globe.1cc21529.svg";